import { defineMessages } from '@edx/frontend-platform/i18n';

const messages = defineMessages({
  iframeTitle: {
    id: 'course-authoring.library-authoring.library-block.iframe-title',
    defaultMessage: 'Preview',
    description: 'The title for the LibraryBlock iframe',
  },
});

export default messages;
